import dayjs from "dayjs";
import type {
	ClientPortfolioReportingSummaryResponseDTO,
	PortfolioReportingEntryResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { roundNumber } from "web_myplann/Utils/formatters";

export type DayData = {
	date: Date;
	invested: number;
	value: number;
};

export const calculateGraphData = (
	data: PortfolioReportingEntryResponseDTO[] | undefined,
	summary: ClientPortfolioReportingSummaryResponseDTO | undefined,
): {
	daysData: DayData[];
	totalValue: number;
	totalInvestedValue: number;
	toDate: string;
	showChartInfo: boolean;
} => {
	if (!data || data.length === 0)
		return {
			daysData: [],
			totalValue: 0,
			totalInvestedValue: 0,
			toDate: "",
			showChartInfo: false,
		};

	const daysData = data.map((i) => ({
		date: new Date(i.date),
		invested: (i.items[0].invested ?? 0) + i.items[0].totalEntryFee,
		value: i.items[0].value,
	}));

	const lastData = daysData[daysData.length - 1];

	const totalValue = roundNumber(summary?.totalValue || 0, 0);
	const totalInvestedValue = roundNumber(summary?.totalInvestedValue || 0, 0);
	const toDate = dayjs(lastData?.date).format("D.M.YYYY");
	const showChartInfo =
		summary?.totalInvestedValue != null &&
		summary?.totalEvaluationValue != null &&
		summary?.totalEvaluationPercent != null;

	return {
		daysData,
		totalValue,
		totalInvestedValue,
		toDate,
		showChartInfo,
	};
};
